import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pushEntity, pushSelectedChipArray } from '../../slices/customQueryBodySlice';
import { pushSelectedDataItem } from '../../slices/customQuerySlice';
import { pushAddOperation } from '../../slices/OperationsCardSlice';
import { pushOpenedAccordion, popClosedAccordion } from '../../slices/entityCardSlice';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Accordion, AccordionSummary, AccordionDetails, Typography, makeStyles, ButtonGroup } from '@material-ui/core';
import consts from '../../utils/consts';
import startCase from 'lodash/startCase';
import camelCase from 'lodash/camelCase';
import { StyledMainDiv } from './EntitiesCardStyle';
import { pushStatus, pushName } from '../../slices/customQueryBodySlice';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';
const StyledAccordionDetails = styled(AccordionDetails)`
  && {
    padding: 0px 16px 0px 16px;
    font-family: 'OpenSans-Regular';
  }
`;
const StyledAccordionSummary = styled(AccordionSummary)`
  & .MuiAccordionSummary-root {
    margin: 0px !important;
  }
  & .MuiAccordionSummary-root.Mui-expanded {
    margin: 0px !important;
  }
`;
const StyledAccordion = styled(Accordion)`
  && {
    margin: 0px !important;
    box-shadow: none;
    font-family: 'OpenSans-Regular';
  }
`;
const StyledEntitiesButton = styled(Button)`
  &.MuiButton-root {
    color: rgba(0, 0, 0, 0.69);
    font-family: 'OpenSans-Regular';
    font-size: 13px !important;
    letter-spacing: 0 !important;
    text-align: left !important;
    background-color: ${props => props.selectedFilter ? '#EFF3F8' : '#fff'};
    border: none;
    justify-content: flex-start !important;
    text-transform: none;
  }
`;
const useStyles = makeStyles(theme => ({
  root: {
    width: '80%'
  },
  heading: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 500,
    textTransform: 'capitalize',
    fontFamily: 'OpenSans-Light'
  },
  direction: {
    width: '100%',
    flexDirection: 'column',
    color: 'rgba(0,0,0,0.69)',
    fontFamily: 'OpenSans-Regular',
    fontSize: '13px',
    letterSpacing: '0'
  }
}));

const RenderAccordian = props => {
  const {
    openedAccordions
  } = useSelector(state => state.entityCard);
  const {
    entityName,
    dispatch,
    selectedChipArray,
    selectedEntityKey,
    selectedEntity
  } = props;
  const {
    userAccountOperations,
    operationsNamesArray,
    userAccountKey,
    riskFilterOperations
  } = consts;
  let {
    entityName: entityHeader,
    entityKeys: entityDetails
  } = entityName;
  const classes = useStyles();
  let isUserAccountExists = selectedChipArray && selectedChipArray.length && selectedChipArray.filter(item => item.indexOf(userAccountKey) > -1).length > 0;
  let entityHeaderLabel = entityHeader;
  let selectedFilter = useSelector(state => state.customQueryBody.name);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      border: 'none'
    }
  }, /*#__PURE__*/React.createElement(StyledAccordion, {
    onChange: expanded => {
      if (expanded) {
        dispatch(pushOpenedAccordion(entityHeader));
      } else {
        dispatch(popClosedAccordion(entityHeader));
      }
    },
    defaultExpanded: openedAccordions.includes(entityHeader)
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null),
    "aria-controls": "panel1a-content",
    id: "panel1a-header",
    style: {
      margin: '0px',
      minHeight: '0px',
      height: '40px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.heading
  }, entityHeaderLabel)), /*#__PURE__*/React.createElement(StyledAccordionDetails, null, /*#__PURE__*/React.createElement(ButtonGroup, {
    vertical: true,
    className: classes.direction
  }, entityDetails.map((entityDetailItem, index) => {
    let isCreatedAt = entityDetailItem.includes('Created');
    let isRiskScore = entityDetailItem === selectedEntity + ' Risk Score';
    let isRiskType = entityDetailItem === selectedEntity + ' Risk Type';
    let matchingKey = entityHeader.substring(0, entityHeader.length - 1);
    let matchRiskScore = entityDetailItem.toLowerCase().includes('risk_score');
    let matchRiskCategory = entityDetailItem.toLowerCase().includes('risk_category');
    matchingKey = entityHeader === 'user accounts' ? 'user' : matchingKey;

    if (entityDetailItem.toLowerCase().includes(matchingKey) || isCreatedAt || isRiskScore || isRiskType && (!matchRiskScore || !matchRiskCategory)) {
      // For rendering only Id and name
      if (selectedEntityKey === entityHeader && entityDetailItem.endsWith('Id')) {
        // If Entity selected, discard Id
        return null;
      }

      if (matchRiskScore || matchRiskCategory) {
        return null;
      } else {
        let labelName = startCase(camelCase(entityDetailItem));
        return /*#__PURE__*/React.createElement(StyledEntitiesButton, {
          key: index,
          disabled: labelName === userAccountKey ? isUserAccountExists : false,
          selectedFilter: selectedFilter === labelName ? true : false,
          name: labelName,
          onClick: event => {
            event.stopPropagation();
            let selectedItem = event.currentTarget.name;
            let selectedRecord = {};
            selectedRecord['recordType'] = entityHeader;
            selectedRecord['keyName'] = selectedItem;
            dispatch(pushSelectedDataItem(selectedRecord));
            dispatch(pushEntity(selectedItem.replace(/_/g, ' ')));
            dispatch(pushStatus(false));
            dispatch(pushName(event.currentTarget.name));
            dispatch(pushSelectedChipArray([]));

            if (isCreatedAt) {
              dispatch(pushAddOperation(userAccountOperations));
            } else if (isRiskScore || isRiskType) {
              dispatch(pushAddOperation(riskFilterOperations));
            } else {
              dispatch(pushAddOperation(operationsNamesArray));
            }
          },
          variant: "light"
        }, labelName);
      }
    }
  })))));
};

const EntitiesCard = () => {
  const accordionKeyItems = useSelector(state => state.entityCard.accordionKeyItems);
  const selectedEntity = useSelector(state => state.customQueryHeader.selectedDataType);
  const dispatch = useDispatch();
  const relatedDataButton = useSelector(state => state.customQueryHeader.relatedDataButton);
  let selectedEntityName = selectedEntity.substring(0, selectedEntity.length - 1);
  let accordionItems = accordionKeyItems.filter(item => relatedDataButton.find(btn => btn.toLowerCase() === item.entityName) || item.entityName === 'applications' || item.entityName === 'environments');

  if (selectedEntity) {
    var selectedEntityKey = selectedEntity.toLowerCase();
    let selectedEntityItem = accordionKeyItems.filter(item => item.entityName === selectedEntityKey);

    if (selectedEntityItem.length > 0) {
      let extraItem = JSON.parse(JSON.stringify(selectedEntityItem));
      selectedEntityName !== 'User' && extraItem[0].entityKeys.push(selectedEntityName + 'Created');

      if (selectedEntityName !== 'Permission' && selectedEntityName !== 'Resource' && selectedEntityName !== 'User') {
        extraItem[0].entityKeys.push(selectedEntityName + ' Risk Type');
        extraItem[0].entityKeys.push(selectedEntityName + ' Risk Score');
      }

      Object.preventExtensions(extraItem);
      accordionItems = accordionItems.concat(extraItem);
    }
  }

  return /*#__PURE__*/React.createElement(StyledMainDiv, null, accordionItems.map((entityCardButtonName, index) => {
    return /*#__PURE__*/React.createElement(RenderAccordian, {
      index: index,
      key: index,
      entityName: entityCardButtonName,
      dispatch: dispatch,
      selectedEntityKey: selectedEntityKey,
      selectedEntity: selectedEntityName
    });
  }));
};

export default EntitiesCard;